const ROTATE_CLASS = 'rotate-180';
const OPTION_SELECTOR = '[data-sticky-atc-option]';

const initProductStickyAtc = () => {
  const stickyAtc = document.querySelector('[data-sticky-atc-wrapper]');
  if (!stickyAtc) return;

  const productControlsEl = document.querySelector('[data-product-controls]');
  const stickyBtn = stickyAtc.querySelector('[data-sticky-atc-btn]');
  const stickyPriceEl = stickyAtc.querySelector('[data-sticky-atc-price]');
  const stickyPriceMsg = stickyBtn?.querySelector('[data-sticky-atc-price-msg]');

  // Custom dropdown elements
  const dropdown = stickyAtc.querySelector('[data-sticky-atc-dropdown]');
  const checkbox = dropdown?.querySelector('[data-sticky-atc-checkbox]');
  const chevron = dropdown?.querySelector('[data-sticky-atc-chevron]');
  const triggerImg = dropdown?.querySelector('[data-sticky-atc-trigger-img]');
  const triggerLabel = dropdown?.querySelector('[data-sticky-atc-trigger-label]');

  const form = document.querySelector('[data-product-main] form');
  const mainAtcButton = form?.querySelector('button[type="submit"]');
  const mainAtcMsg = mainAtcButton?.querySelector('[data-atc-price-msg]');

  // Sync disabled state and button message from main ATC button
  const syncButtonState = () => {
    if (!mainAtcButton) return;
    stickyBtn.disabled = mainAtcButton.disabled;
    if (stickyPriceMsg && mainAtcMsg) stickyPriceMsg.textContent = mainAtcMsg.textContent;
  };

  if (mainAtcButton) {
    syncButtonState();
    new MutationObserver(syncButtonState).observe(mainAtcButton, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  // Sync price from main product price element
  const mainPriceEl = document.querySelector('[data-product-price-pdp] [data-product-price]');
  const syncPrice = () => {
    if (stickyPriceEl && mainPriceEl) stickyPriceEl.textContent = mainPriceEl.textContent;
  };
  if (mainPriceEl) {
    new MutationObserver(syncPrice).observe(mainPriceEl, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  // Chevron tracks dropdown checkbox
  checkbox?.addEventListener('change', () => {
    chevron?.classList.toggle(ROTATE_CLASS, checkbox.checked);
  });

  // Close dropdown on outside click
  document.addEventListener('mousedown', e => {
    if (checkbox?.checked && dropdown && !dropdown.contains(e.target)) {
      checkbox.checked = false;
      chevron?.classList.remove(ROTATE_CLASS);
    }
  });

  // Custom dropdown option selection
  dropdown?.addEventListener('click', e => {
    const opt = e.target.closest(OPTION_SELECTOR);
    if (!opt) return;

    const { optionValue, optionName, swatchUrl } = opt.dataset;

    // Update trigger display
    if (triggerImg && triggerImg.tagName === 'IMG' && swatchUrl) triggerImg.src = swatchUrl;
    if (triggerLabel) triggerLabel.textContent = optionValue;

    // Update checkmarks
    dropdown.querySelectorAll('[data-sticky-atc-option-check]').forEach(check => {
      check.classList.toggle('hidden', check.closest(OPTION_SELECTOR) !== opt);
    });

    // Close dropdown
    if (checkbox) checkbox.checked = false;
    chevron?.classList.remove('rotate-180');

    // Fire change on the corresponding main radio input
    const radio = document.querySelector(`[data-variant-input][name="${optionName}"][value="${optionValue}"]`);
    if (radio && !radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  // Sync trigger when main variant changes (user uses main shade swatches)
  const syncTriggerFromMain = () => {
    const activeSwatch = document.querySelector('[data-shade-swatch][data-active]');
    if (!activeSwatch) return;
    const { swatchUrl, optionValue } = activeSwatch.dataset;
    if (triggerImg && triggerImg.tagName === 'IMG' && swatchUrl) triggerImg.src = swatchUrl;
    if (triggerLabel) triggerLabel.textContent = optionValue || '';

    // Sync checkmarks in dropdown list
    dropdown?.querySelectorAll('[data-sticky-atc-option]').forEach(opt => {
      const check = opt.querySelector('[data-sticky-atc-option-check]');
      if (check) check.classList.toggle('hidden', opt.dataset.optionValue !== optionValue);
    });
  };

  document.querySelectorAll('[data-variant-input]').forEach(input => {
    input.addEventListener('change', syncTriggerFromMain);
  });
  syncTriggerFromMain();

  // Show/hide on scroll
  if (productControlsEl) {
    const getBottom = el => el.getBoundingClientRect().top + window.scrollY + el.offsetHeight;
    const handleScroll = () => {
      stickyAtc.classList.toggle('hidden', window.scrollY < getBottom(productControlsEl));
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
  }

  stickyBtn?.addEventListener('click', () => {
    mainAtcButton?.click();
  });
};

const initAppBlockAtc = () => {
  const proxyBtn = document.querySelector('[data-app-block-atc-btn]');
  if (!proxyBtn) return;

  const form = document.querySelector('[data-product-main] form');
  const mainAtcButton = form?.querySelector('button[type="submit"]');
  if (!mainAtcButton) return;

  const mainAtcMsg = mainAtcButton.querySelector('[data-atc-price-msg]');
  const proxyMsg = proxyBtn.querySelector('[data-app-block-atc-msg]');
  const proxySpinner = proxyBtn.querySelector('[data-icon-spinner]');
  const mainSpinner = mainAtcButton.querySelector('[data-icon-spinner]');

  const sync = () => {
    proxyBtn.disabled = mainAtcButton.disabled;
    if (proxyMsg && mainAtcMsg) proxyMsg.textContent = mainAtcMsg.textContent;
    if (proxySpinner && mainSpinner) proxySpinner.classList.toggle('hidden', mainSpinner.classList.contains('hidden'));
  };

  sync();
  new MutationObserver(sync).observe(mainAtcButton, {
    attributes: true,
    childList: true,
    subtree: true,
    characterData: true
  });

  proxyBtn.addEventListener('click', () => mainAtcButton.click());
};

export { initAppBlockAtc };
export default initProductStickyAtc;
